<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="custom-title">{{'Voltar' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido"></div>
  <div *ngIf="enquete.id">
    <div class="container">
      <img *ngIf="enquete.imagem" [src]="enquete.imagem | image:' '" />

      <img
        *ngIf="!enquete.imagem"
        [src]="'http://sis.sistemaprover.com.br/public/img/enquete_placeholder.png' | image:' '"
      />
    </div>

    <ion-card-content>
      <ion-card-title>
        <div class="text-center">
          <p class="titulo" style="white-space: unset !important">{{enquete.descricao}}</p>
        </div>

        <div class="text-center">
          <p class="finalizada">
            {{'Enquete Finalizada' | translate}}

            <i class="fas fa-check-circle enquete-icon"></i>
          </p>
        </div>
      </ion-card-title>
    </ion-card-content>
  </div>

  <div *ngIf="!userProvider.hasConfig(146) && enquete.id">
    <ion-item lines="none">
      <ion-label class="resp">{{'Respostas:' | translate}}</ion-label>
    </ion-item>

    <div *ngFor="let pergunta of perguntas; index as i">
      <ion-item>
        <ion-label class="alinhamento">
          <p class="titulo-resposta">{{i + 1}} - {{pergunta.pergunta}}</p>
          
          <p 
            *ngFor="let resposta of pergunta.respostas; let i = index" class="resposta"
            [ngClass]="{'line-bottom':  pergunta.respostas.length > 1 && i <  pergunta.respostas.length - 1}">
            <span>{{'Resposta:' | translate}}</span>
            {{ resposta.alternativa ? resposta.alternativa
            : resposta.resposta ? resposta.resposta
            : ('Não Respondido' | translate)}}
          </p>
        </ion-label>
      </ion-item>
    </div>
  </div>
</ion-content>
<ion-footer class="ion-no-border">
  <ion-toolbar *ngIf="loaded">
    <div class="ion-text-center" style="width: 100%">
      <ion-button (click)="closeModal()" class="btn-default">{{'Voltar ao início' | translate}}</ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
